import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-4 pb-10 md:pt-6 md:pb-14 overflow-hidden bg-cream" data-id="element-137">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-138">
        <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-amber-500/5 blur-3xl" data-id="element-139" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-3xl text-center" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-5 py-2 mb-5 rounded-full border border-amber-500/30 bg-amber-50 text-teal-900 font-semibold tracking-wider uppercase text-[12px]" data-id="element-141">
          MÉTODO CONECTA-TEA
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-sans md:text-5xl font-extrabold text-teal-900 mb-5 text-[20px]" data-id="element-142">
          La ayuda que tu hijo necesita para comunicarse, lista desde hoy.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mb-6" data-id="element-143">
          <img src="https://cdn.magicpatterns.com/uploads/bFyXXNtWqgxu3Jfd6jdHoi/Texto_del_parrafo_(9).webp" alt="Método Conecta-TEA — Sistema Integral de Comunicación Visual" width={672} height={672} loading="eager" fetchPriority="high" decoding="async" sizes="(max-width: 768px) 100vw, 672px" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-2xl shadow-teal-900/10" data-id="element-144" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:text-xl text-stone-600 mb-6 max-w-xl mx-auto text-[16px]" data-id="element-145">
          Darle voz a tu hijo con TEA, eliminar las crisis y recuperar la paz en
          el hogar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-146">
          <Button variant="amber" size="lg" href="#pricing" className="w-full sm:w-auto shadow-xl shadow-amber-500/20 text-base tracking-wide" data-id="element-147">
            QUIERO ACCEDER AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}